import { legalityTypes, investigationTypes, placeholders } from '../case-data';
import { getCase, updateCase } from './../../../actions/case-actions';
import Swal from 'sweetalert2';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import '../../../styles/cases.css';
import { Link, useParams } from 'react-router-dom';

function LegalityForm(){
    const currentLink = "/casos";
    const dispatch = useDispatch();
    const [loadData, setLoadData] = useState(true);
    const params = useParams();
    const user = useSelector(state => state.user.user);

    const [currentData, setCurrentData] = useState({});
    const [currentCityPlaceholder, setCurrentCityPlaceholder] = useState({
        amount: '',
        instances: ''
    });


    const [form, setForm] = useState({
        type: '',
        investigatedCorrect: true,
        investigatedObservation: '',
        policyNumber: '',
        insuredValue: '',
        amount: '',
        instance: '',
        proof: '',
        elementsOfDamage: '',
        recusation: '',
        nullity: '',
        expiration: '',
        foisted: '',
        pass: true,
        rejectionReason: ''
    })

    useEffect(() => {
        if (loadData) {
            const getFunction = (data) => {
                if(data.code === "01"){
                    Swal.fire({
                        title:"Error",
                        confirmButtonColor:"#76b4ff",
                        text: data.message
                    });
                }else{
                    if (data.data.status === 'not checked') {
                        Swal.fire({
                            title:"¡Atención!",
                            confirmButtonColor:"#76b4ff",
                            text:"Para diligenciar este documento, debe asignar previamente una compañía aseguradora al caso",
                        });
                        return;
                    }

                    let clientPosition = `${data.data.case.statePosition === 'ex'?'ex':''} ${data.data.case.position}`;
                    data.data.clientText = `${data.data.client.clientId.firstName} ${data.data.client.clientId.lastName} ${data.data.client.clientId.documentType}: ${data.data.client.clientId.document} - ${clientPosition}`.toLocaleUpperCase();
                    data.data.entityText = `${data.data.case.territorialEntity} - ${data.data.case.executionCity} ${data.data.case.executionProvince}`.toLocaleUpperCase();
                    data.data.companyText = `${data.data.company.companyId.description} - ${data.data.company.companyId.city} ${data.data.company.companyId.province}`.toLocaleUpperCase();

                    for (let index = 0; index < investigationTypes.length; index++) {
                        if (data.data.caseType === investigationTypes[index].value) {
                            data.data.caseType = investigationTypes[index].name.toLocaleUpperCase()
                        }
                    }

                    switch (data.data.city) {
                        case 'Cali':
                            setCurrentCityPlaceholder({
                                ...placeholders.cali
                            })
                            break;
                        case 'Palmira':
                            setCurrentCityPlaceholder({
                                ...placeholders.palmira
                            })
                            break;
                        default:
                            break;
                    }

                    setCurrentData(data.data);

                    setForm({
                        ...form,
                        ...data.data.legalityControl,
                    })

                }
            }

            setLoadData(false);
            setForm({
                type: '',
                investigatedCorrect: true,
                investigatedObservation: '',
                policyNumber: '',
                insuredValue: '',
                amount: '',
                instance: '',
                proof: '',
                elementsOfDamage: '',
                recusation: '',
                nullity: '',
                expiration: '',
                foisted: '',
                pass: true,
                rejectionReason: ''
            });
            dispatch( getCase( params.id, getFunction, user.token ) );
        }
    }, [loadData, dispatch, params.id, form, user.userType, user.token ]);

    const handleInputChange = (event) => {
        setForm({
            ...form,
            [event.target.name] :  event.target.value
        })
    }

    const handleCheck = (event) => {
        switch (event.target.name) {
            case 'investigatedCorrect':
                setForm({
                    ...form,
                    [event.target.name]: event.target.checked,
                    investigatedObservation: ''
                })
                break;
            case 'pass':
                setForm({
                    ...form,
                    [event.target.name]: event.target.checked,
                    rejectionReason: ''
                })
                break;
            default:
                break;
        }
    }

    const validateFields = () => {
        if (currentData.caseType !== 'FISCAL') {
            for (const field in form) {
                if (form.hasOwnProperty(field)) {
                    //console.log(`${field}: ${form[field]}`);
                    if (field === 'investigatedCorrect' && !form[field] && form.investigatedObservation === '') {
                        return true
                    }
                    if (field === 'pass' && !form[field] && form.rejectionReason === '') {
                        return true
                    }
                    if ( field !== 'investigatedObservation' && field !== 'policyNumber' && field !== 'insuredValue' &&
                        field !== 'amount' && field !== 'instance' &&  field !== 'elementsOfDamage' && field !== 'rejectionReason' && form[field] === '') {
                        return true
                    }
                }
            }
        } else {
            for (const field in form) {
                if (form.hasOwnProperty(field)) {
                    //console.log(`${field}: ${form[field]}`);
                    if (field === 'investigatedCorrect' && !form[field] && form.investigatedObservation === '') {
                        return true
                    }
                    if (field === 'pass' && !form[field] && form.rejectionReason === '') {
                        return true
                    }
                    if ( field !== 'investigatedObservation' && field !== 'rejectionReason' && form[field] === '' ) {
                        return true
                    }
                }
            }
        }
        return false
    }

    const handleOnSubmit = (event) => {
        event.preventDefault();
        const isEmpty = validateFields();
        if (isEmpty) {
            Swal.fire({
                title:"¡Atención!",
                confirmButtonColor:"#76b4ff",
                text:"Debe llenar todos los datos para continuar",
            });
        } else {
            const data = {
                _id: currentData._id,
                legalityControl: {
                    ...form
                }
            }
            dispatch( updateCase(data,updateFunction, user.token) );
        }
    }

    const updateFunction = (data) => {
        if(data.code === "01"){
            Swal.fire({
                title:"Error",
                confirmButtonColor:"#76b4ff",
                text: data.message
            });
        }else{
            //navigate(currentLink)
            //console.log(data);
            Swal.fire({
                title:"¡Éxito!",
                confirmButtonColor:"#76b4ff",
                text: "Control registrado con éxito"
            });
        }
    }

    useEffect(() => {
        //console.log(form);
    }, [ form ]);

    return(
        <div className="w-100 d-flex">
            <div className="container d-flex flex-column">
                <div className="w-100 mt-5">
                    <Link to={currentLink + '/control'} className="back-button">&#60; Volver</Link>
                </div>
                <h1 className="my-5">Información legal del caso</h1>
                {Object.keys(currentData).length > 0?
                    <form className="d-flex w-100 flex-wrap" onSubmit={handleOnSubmit}>
                        <h4 className="w-100 my-2">Datos generales</h4>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="type">1&#46; Documento</label>
                            <select className="input-field" id="type" name="type" onChange={handleInputChange} value={form.type}>
                                <option></option>
                                {legalityTypes.map((type, index) => (
                                    <option key={index} value={type.value}>{type.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field">2&#46; Órgano</label>
                            <span className='field'>{currentData.researchOrgan.organId.description}</span>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field">3&#46; Tipo de proceso</label>
                            <span className='field'>{currentData.caseType}</span>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field">4&#46; Radicado</label>
                            <span className='field'>{currentData.filingNumber}</span>
                        </div>
                        <h4 className="w-100 my-2">Investigados</h4>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field">5&#46;1 Investigado&#47;a</label>
                            <span className='field'>{currentData.clientText}</span>
                        </div>
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="investigatedCorrect">5&#46;2 ¿Están plena y correctamente identificados en el auto?</label>
                            <input type="checkbox" autoComplete='off' className="input-field" id="investigatedCorrect" name="investigatedCorrect" onChange={handleCheck} checked={form.investigatedCorrect}></input>
                        </div>
                        {!form.investigatedCorrect?
                            <div className="d-flex flex-column w-3 field">
                                <label className="label-field" htmlFor="investigatedObservation">5&#46;3 ¿Por qué no lo están?</label>
                                <input id='investigatedObservation' name="investigatedObservation" autoComplete="off" maxLength={100} className="input-field" type="text" onChange={handleInputChange} value={form.investigatedObservation}></input>
                            </div>
                        :
                            null
                        }
                        <div className="d-flex flex-column w-3 field">
                            <label className="label-field" htmlFor="position">6&#46; Entidad afectada</label>
                            <span className='field'>{currentData.entityText}</span>
                        </div>
                        {currentData.caseType === 'FISCAL' ?
                            <div className="d-flex w-100 flex-wrap">
                                <h4 className="w-100 my-2">Aseguradora</h4>
                                <div className="d-flex flex-column w-3 field">
                                    <label className="label-field">7&#46;1 Compañía aseguradora</label>
                                    <span className='field'>{currentData.companyText}</span>
                                </div>
                                <div className="d-flex flex-column w-3 field">
                                    <label className="label-field" htmlFor="policyNumber">7&#46;2 Número de póliza</label>
                                    <input id='policyNumber' name="policyNumber" autoComplete="off" maxLength={100} className="input-field" type="text" onChange={handleInputChange} value={form.policyNumber}></input>
                                </div>
                                <div className="d-flex flex-column w-3 field">
                                    <label className="label-field" htmlFor="insuredValue">7&#46;3 Valor asegurado</label>
                                    <input id='insuredValue' name="insuredValue" autoComplete="off" maxLength={100} className="input-field" type="text" onChange={handleInputChange} value={form.insuredValue}></input>
                                </div>
                                <div className="d-flex flex-column w-100 field">
                                    <label className="label-field" htmlFor={'amount'}>8&#46; Cuantía</label>
                                    <textarea id={'amount'} name={'amount'} placeholder={currentCityPlaceholder.amount} autoComplete="off" rows={5} cols={5} className="input-field" onChange={handleInputChange} value={form.amount}></textarea>
                                </div>
                                <div className="d-flex flex-column w-100 field">
                                    <label className="label-field" htmlFor={'instance'}>9&#46; Instancias</label>
                                    <textarea id={'instance'} name={'instance'} placeholder={currentCityPlaceholder.instances} autoComplete="off" rows={5} cols={5} className="input-field" onChange={handleInputChange} value={form.instance}></textarea>
                                </div>
                            </div>
                        :
                            null
                        }
                        <div className="d-flex flex-column w-100 field">
                            <label className="label-field" htmlFor={'proof'}>10&#46; Pruebas</label>
                            <textarea id={'proof'} name={'proof'} placeholder={placeholders.proof} autoComplete="off" rows={5} cols={5} className="input-field" onChange={handleInputChange} value={form.proof}></textarea>
                        </div>
                        {currentData.caseType === 'FISCAL' ?
                            <div className="d-flex flex-column w-100 field">
                                <label className="label-field" htmlFor={'elementsOfDamage'}>11&#46; Acreditación de elementos del daño</label>
                                <textarea id={'elementsOfDamage'} name={'elementsOfDamage'} placeholder={placeholders.elementsOfDamage} autoComplete="off" rows={5} cols={5} className="input-field" onChange={handleInputChange} value={form.elementsOfDamage}></textarea>
                            </div>
                        :
                            null
                        }
                        <div className="d-flex flex-column w-100 field">
                            <label className="label-field" htmlFor={'recusation'}>12&#46; Recusación&#47;Impedimentos</label>
                            <textarea id={'recusation'} name={'recusation'} placeholder={placeholders.recusation} autoComplete="off" rows={5} cols={5} className="input-field" onChange={handleInputChange} value={form.recusation}></textarea>
                        </div>
                        <div className="d-flex flex-column w-100 field">
                            <label className="label-field" htmlFor={'nullity'}>13&#46; Causales de nulidad</label>
                            <textarea id={'nullity'} name={'nullity'} placeholder={placeholders.nullity} autoComplete="off" rows={5} cols={5} className="input-field" onChange={handleInputChange} value={form.nullity}></textarea>
                        </div>
                        <div className="d-flex flex-column w-100 field">
                            <label className="label-field" htmlFor={'expiration'}>14&#46; Estado del término de caducidad de la acción y prescripción</label>
                            <textarea id={'expiration'} name={'expiration'} placeholder={placeholders.expiration} autoComplete="off" rows={5} cols={5} className="input-field" onChange={handleInputChange} value={form.expiration}></textarea>
                        </div>
                        <div className="d-flex flex-column w-100 field">
                            <label className="label-field" htmlFor={'foisted'}>15&#46; Conducta endilgada</label>
                            <textarea id={'foisted'} name={'foisted'} placeholder={placeholders.foisted} autoComplete="off" rows={5} cols={5} className="input-field" onChange={handleInputChange} value={form.foisted}></textarea>
                        </div>
                        <h4 className="w-100 my-2">Control</h4>
                        <div className="w-100 d-flex d-flex justify-content-center field">
                            <label className="label-field" style={{margin: 0}} htmlFor="pass">Revisado el caso, yo {`${user.firstName} ${user.lastName}`} encuentro el control de legalidad de este caso: {form.pass?'Válido':'No válido'}</label>
                            <input type="checkbox" autoComplete='off' className="input-field" style={{marginLeft: 10}} id="pass" name="pass" onChange={handleCheck} checked={form.pass}></input>
                        </div>
                        {!form.pass?
                            <div className="d-flex flex-column w-100 field">
                                <label className="label-field" htmlFor={'rejectionReason'}>Razón</label>
                                <textarea id={'rejectionReason'} name={'rejectionReason'} placeholder={'Razón por la cual el caso no pudo pasar el control de legalidad'} autoComplete="off" rows={5} cols={5} className="input-field" onChange={handleInputChange} value={form.rejectionReason}></textarea>
                            </div>
                        :
                            null
                        }
                        <div className="d-flex justify-content-center w-100 my-2">
                            <button type="submit" className="primary-button save-button">Guardar</button>
                        </div>
                    </form>
                :
                    null
                }

                
            </div>
        </div>
    );
}

export default LegalityForm;